import React from 'react';

const BtnStopExec = (props) => {
  return (
      <button className="btn-delete" onClick={()=>props.handleStop()}>Stop Exec</button>
  );
}

export default BtnStopExec;
